module.exports = __webpack_public_path__ + "static/media/christophe.b5fb85f6.jpg";